import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Box, Grid, Card, CardMedia, CardContent, Typography, Button } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import getLearningPathData from "../dashboard/api";

import {
  IoTdevelopercourses,
  IoTDataScientistcourses,
  IndustrialiotCourses,
} from "../Courses/coursesdata";

import {
  IoTdeveloperProjects,
  IoTDataScientistProjects,
  IndustrialProjects,
} from "../Courses/projectsData";

import Iotdeveloper from "../../../../../assets/learnersDashboard/iotdeveloperengineer.webp";
import Industrialiot from "../../../../../assets/learnersDashboard/industrialiot.webp";
import Iotsecurity from "../../../../../assets/learnersDashboard/iotsecurity.webp";
import Iotdatascientist from "../../../../../assets/learnersDashboard/Iotdatascientist.webp";
import Iothardware from "../../../../../assets/learnersDashboard/iothardware.webp";
import Starts from "../../../../../assets/learnersDashboard/8.webp";
import Bootcamps from "../../../../../assets/learnersDashboard/iotbootcamps.webp";

const LearningPath = () => {
  const [clickedPaths, setClickedPaths] = useState({});
  const [allProgressData, setAllProgressData] = useState({});

  useEffect(() => {
    const saved = localStorage.getItem("clickedPaths");
    if (saved) {
      setClickedPaths(JSON.parse(saved));
    }
  }, []);

  const handleStartClick = (path) => {
    const updatedPaths = { ...clickedPaths, [path]: true };
    setClickedPaths(updatedPaths);
    localStorage.setItem("clickedPaths", JSON.stringify(updatedPaths));
  };

  const renderButton = (path) => {
    const isClicked = clickedPaths[path];
    return (
      <Button
        variant="outlined"
        fullWidth
        startIcon={<PlayArrowIcon />}
        sx={{
          mt: 1,
          fontWeight: 600,
          borderColor: "#1B6EF4",
          color: "#1B6EF4",
          "&:hover": {
            bgcolor: "#1B6EF4",
            color: "#fff",
          },
        }}
        onClick={() => handleStartClick(path)}
      >
        {isClicked ? "Resume" : "Start Learning"}
      </Button>
    );
  };

  const renderComingSoon = (label = "Coming Soon") => (
    <Button
      disabled
      variant="outlined"
      size="small"
      sx={{
        mt: 2,
        fontWeight: 600,
        borderColor: "#999",
        color: "#999",
        cursor: "not-allowed",
      }}
    >
      {label}
    </Button>
  );

  const cardsData = [
    {
      title: "IoT Developer / Engineer",
      //description: "Master IoT programming, protocols, sensors, and real-time systems.",
      img: Iotdeveloper,
      link: "./iot-developer-engineer",
      path: "iot-developer-engineer",
    },
    {
      title: "IoT Data Scientist",
      //description: "Analyze IoT data, build ML models, and make smarter predictions.",
      img: Iotdatascientist,
      link: "./iot-data-scientist",
      path: "iot-data-scientist",
    },
    {
      title: "Industrial IoT & Industry 4.0",
      //description: "Digitize factories, use edge devices, and automate industrial systems.",
      img: Industrialiot,
      link: "./industrial-iot-industry",
      path: "industrial-iot-and-industry",
    },
    {
      title: "IoT Security Specialist",
      //description: "Secure IoT devices and networks (Coming Soon).",
      img: Iotsecurity,
      comingSoon: true,
    },
    {
      title: "IoT Hardware Engineer",
      //description: "Design and interface IoT hardware (Coming Soon).",
      img: Iothardware,
      comingSoon: true,
    },
    {
      title: "Hands-On IoT Boot Camps",
      //description: "Accelerated IoT skill-building with hands-on workshops.",
      img: Bootcamps,
      link: "./iot-boot-camps",
      path: "iot-boot-camps",
    },
    {
      title: "Customized Learning Path with AI",
      //description: "Get a tailored IoT curriculum powered by AI (Coming Soon).",
      img: Starts,
      comingSoon: true,
    },
  ];

  useEffect(() => {
    const fetchAllProgress = async () => {
      const newProgress = {};

      for (const card of cardsData) {
        if (card.comingSoon) continue;

        let selectedData = { courses: [], projects: [] };

        switch (card.title) {
          case "IoT Developer / Engineer":
            selectedData = {
              courses: IoTdevelopercourses[0]?.courses || [],
              projects: IoTdeveloperProjects[0]?.projects || [],
            };
            break;
          case "IoT Data Scientist":
            selectedData = {
              courses: IoTDataScientistcourses[0]?.courses || [],
              projects: IoTDataScientistProjects[0]?.projects || [],
            };
            break;
          case "Industrial IoT & Industry 4.0":
            selectedData = {
              courses: IndustrialiotCourses[0]?.courses || [],
              projects: IndustrialProjects[0]?.projects || [],
            };
            break;
          default:
            selectedData = { courses: [], projects: [] };
        }

        try {
          await getLearningPathData(
            card.title,
            selectedData.courses,
            selectedData.projects,
            (data) => {
              newProgress[card.path] = data;
            }
          );
        } catch (err) {
          console.error("Progress fetch failed for:", card.title, err);
        }
      }

      setAllProgressData(newProgress);
    };

    fetchAllProgress();
  }, []);

  return (
    <div className="mylearningpaths">
      <Box sx={{ margin: "4px 40px" }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Box
            sx={{
              backgroundColor: "#E3F2FD",
              color: "#043885",
              borderRadius: "50%",
            }}
          >
            <i className="fas fa-bullseye" style={{ fontSize: 20 }} />
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#052659",
            }}
          >
            Learning Path
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary" mb={4}>
          Choose your IoT learning Path and start building your expertise
        </Typography>

        <Grid container spacing={6} justifyContent="center" alignItems="stretch" sx={{ paddingBottom : "20px" }}>
          {cardsData.map((card, index) => (
            <Grid
              item
              key={index}
              xs={12}
              sm={6}
              md={4}
              display="flex"
            >
              <Card
               sx={{
                  width : 330,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                  borderRadius: 3,
                  boxShadow: 4,
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: 6,
                  },
                }}
              >
                <Box sx={{ position: "relative" }}>
                  <CardMedia
                    component="img"
                    image={card.img}
                    alt={card.title}
                    sx={{ height : 160, width : "100%" }}
                  />
                  {!card.comingSoon && card.path !== "iot-boot-camps" && (
                    <Box
                      sx={{
                        position: "absolute",
                        top : 8,
                        right : 8,
                        bgcolor: "rgba(0, 0, 0, 0.8)",
                        color: "#fff",
                        px: 1,
                        py: 0.5,
                        borderRadius: 2,
                        fontSize: "0.75rem",
                        fontWeight: 500,
                      }}
                    >
                      {`${Math.round(allProgressData[card.path]?.learningPathProgress || 0)}% Complete`}
                    </Box>
                  )}
                </Box>

                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    textAlign: "left",
                    px: 2,
                  }}
                >
                  <Typography
                    fontWeight="bold"
                    sx={{ color: "#043885", mb: 0.5 }}
                  >
                    {card.title}
                  </Typography>

                  {/* <Typography
                    variant="body2"
                    sx={{ color: "#444", mb: 1.5, fontSize: "0.9rem" }}
                  >
                    {card.description}
                  </Typography> */}

                  {!card.comingSoon && card.path !== "iot-boot-camps" && (
                    <>
                     <Box sx={{ width : "100%", mb: 2 }}>
                      <Box display="flex" justifyContent="space-between" mb={0.5}>
                        <Typography variant="caption" color="text.secondary">
                          Progress
                        </Typography>
                        <Typography variant="caption" fontWeight={600} color="#052659">
                          {`${Math.round(allProgressData[card.path]?.learningPathProgress || 0)}%`}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          height : 8,
                          width : "100%",
                          backgroundColor: "#f0f3f8",
                          borderRadius: 10,
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          sx={{
                            height : "100%",
                            width : `${Math.round(allProgressData[card.path]?.learningPathProgress || 0)}%`,
                            backgroundColor: "#052659", // Match dark navy tone from screenshot
                            borderRadius: 10,
                            transition: "width 0.5s ease",
                          }}
                        />
                      </Box>
                    </Box>
                    </>
                  )}

                  {card.comingSoon ? (
                    renderComingSoon()
                  ) : (
                    <Link to={card.link} style={{ textDecoration: "none", width : "100%" }}>
                      {renderButton(card.path)}
                    </Link>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default LearningPath;
